module.exports = __webpack_public_path__ + "static/media/baseLR_top.6e670697.png";